import { ref } from 'vue';
import { defineStore } from 'pinia';
import {
  CUSTOMIZABLE_SHORTCUTS,
  type Shortcuts,
} from 'src/constants/shortcuts';
import  { Language } from 'src/types/language';

interface UserConfig {
  shortcuts: Shortcuts;
  language: Language;
}

export const useUserStore = defineStore(
  'user',
  () => {
    const config = ref<UserConfig>({
      shortcuts: CUSTOMIZABLE_SHORTCUTS,
      language: Language.DUTCH,
    });

    function getMappedShortcut (shortcut: keyof Shortcuts): string {
      return config.value.shortcuts[shortcut] ?? null;
    }

    function updateShortcut (shortcut: keyof Shortcuts, value: string) {
      config.value.shortcuts[shortcut] = value;
    }

    function updateLanguage (language: Language) {
      config.value.language = language;
    }

    return { config, getMappedShortcut, updateShortcut, updateLanguage };
  },
  {
    persist: true,
  },
);
